import { render, staticRenderFns } from "./Exercise-layout.vue?vue&type=template&id=66c1e753&scoped=true&lang=pug"
import script from "./Exercise-layout.vue?vue&type=script&lang=js"
export * from "./Exercise-layout.vue?vue&type=script&lang=js"
import style0 from "./Exercise-layout.vue?vue&type=style&index=0&id=66c1e753&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c1e753",
  null
  
)

export default component.exports